import { Component, Input, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import {
	GrupoClientes
} from "@sharedV11/classes/clients/client/grupos-cliente-Respuesta.model";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
	DatosLista
} from "../../categorias-jerarquias/model/model";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { MaestrasService } from "@sharedV11/services/core/maestras.service";
import { InsUpSchemaRequest, InsUpSchemaResponse, ISchema, ISchemaFormValue, ISchemaScript } from "../model/model";
import moment from "moment";


@Component({
	selector: "app-edit-schema",
	templateUrl: "./edit-schema.component.html",
	styleUrls: ["./edit-schema.component.scss"],
})
export class EditSchemaComponent implements OnInit {
	public loading: boolean = true;
	private ngUnsubscribe = new Subject();

	@Input() pkId: string;
	@Input() mode: string;
	@Input() modificar: boolean;

	translation: any;
	editForm: FormGroup;

	schemaValue: ISchema;

	// datos lista
	padres: DatosLista[] = [];

	// Tipo Elemento
	tipoElemento = [
		{
			name: "Tienda",
			value: 2,
		},
		{
			name: "Restauración",
			value: 3,
		},
	];

	//grupos internet dual list
	gruposInternetSinAsignar = [];
	private _gruposInternetAsignados = [];
	get gruposInternetAsignados() {
		return this._gruposInternetAsignados;
	}
	set gruposInternetAsignados(value: any[]) {
		this._gruposInternetAsignados = value;
		// Limpiar error cuando se seleccionan grupos
		if (value && value.length > 0) {
			if (this.formControls && this.formControls["GruposInternetIds"]?.hasError('required')) {
				this.formControls["GruposInternetIds"].setErrors(null);
			}
		}
	}

	listaPaises: Array<{name: string, code: string}> = [];

	//centros
	format = {
		add: "Añadir",
		remove: "Borrar",
		all: "Todos",
		none: "Ninguno",
		direction: DualListComponent.LTR,
		draggable: true,
		locale: "es",
	};

	constructor(
		private snackvar_service: SnackbarInfoService,
		private panelService: PanelService,
		private fb: FormBuilder,
		private translator: Translator,
		private httpErrorService: HttpErrorsService,
		private gsCentros: GlobalServicCentros,
		private conectarApiService: ConectarApiService,
		private maestras: MaestrasService
	) {}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	ngOnInit(): void {
		this.initializeTranslate();
		this.initializeFormWithoutData();
		this.loadData();
	}

	loadData() {
		this.listaPaises = this.maestras.getPaisesISO3166A2();

		this.conectarApiService.getDatosListasMS({
      nombreTabla: 'gruposinternet'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.gruposInternetSinAsignar = hasData ? data?.datosResult?.datosListas : [];

			this.manageForm(this.pkId, this.mode);
    }, (error) => {
			this.loading = false;
			this.httpErrorService.identificarErroresMicroservicios(error);
		});

	}

	async initializeTranslate() {
		this.translation = this.translator.GetTranslations();
		this.format = {
			add: this.translation.Anadir,
			remove: this.translation.Borrar,
			all: this.translation.Todos,
			none: this.translation.Ninguno,
			direction: DualListComponent.LTR,
			draggable: true,
			locale: "es",
		};
	}

	findSchema(pkId) {
		this.conectarApiService
			.getSchemaByPkid(pkId)
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe(
				(data) => {
					if (data) {
						this.schemaValue = data;
						this.changeValueForm(data);
						this.gruposInternetAsignados = this.getGruposInternetAsignados(
							data?.grupoInternetIds || ''
						);
					}
					this.valuedChanged();
					this.loading = false;
				},
				(error) => {
					this.httpErrorService.identificarErrores(error);
				}
			);
	}

	getGruposInternetAsignados(joinIds: string) {
		if (!joinIds || joinIds.length === 0) return [];
		const ids = joinIds.split(",").map((id) => id.trim()).map(Number);
		const gruposAsignados = this.gruposInternetSinAsignar.filter((grupo) =>
			ids.includes(grupo.pkid)
		);

		return gruposAsignados;
	}

	initializeFormWithoutData() {
		this.editForm = this.fb.group({
			NombreEvento: ["", [Validators.required]],
			DescripcionEvento: ["", [Validators.required]],
			URLImagen: ["", [this.ValidatorImageURL()]],
			NombreOrganizador: ["", [Validators.required]],
			WebOrganizador: ["", [this.ValidatorURL()]],
			FechaDeInicio: ["", [this.ValidatorDatePicker(true)]],
			FechaDeFin: ["", [this.ValidatorDatePicker()]],
			HoraInicio: ["", [Validators.required]],
			HoraFin: ["", [Validators.required]],
			NombreLugarEvento: ["", [Validators.required]],
			Direccion: ["", [Validators.required]],
			Localidad: ["", [Validators.required]],
			Region: ["", [Validators.required]],
			PaisCodigo: ["", [Validators.required]],
			CodigoPostal: ["", [Validators.required]],
			PublicacionDesde: ["", [this.ValidatorDatePicker()]],
			PublicacionHasta: ["", [this.ValidatorDatePicker()]],
			GruposInternetIds: [""],
			Activo: [true],
		});
	}

	changeValueForm(data: ISchema) {
		if (!data) {
			this.editForm.reset();
			this.panelService.setDiscardChanges(true);
			return;
		}

		const scriptData = this.getDataFromScript(data.script);

		this.formControls["NombreEvento"].setValue(data.nombre);
		this.formControls["DescripcionEvento"].setValue(data.descripcion);
		this.formControls["URLImagen"].setValue(scriptData?.image || '');
		this.formControls["NombreOrganizador"].setValue(scriptData?.organizer?.name || '');
		this.formControls["WebOrganizador"].setValue(scriptData?.organizer?.url || '');
		this.formControls["FechaDeInicio"].setValue(data.fechaInicio ? moment(data.fechaInicio, 'YYYY/MM/DD HH:mm:ss').toDate() : '');
		this.formControls["FechaDeFin"].setValue(data.fechaFin ? moment(data.fechaFin, 'YYYY/MM/DD HH:mm:ss').toDate() : '');
		this.formControls["HoraInicio"].setValue(data.fechaInicio ? moment(data.fechaInicio, 'YYYY/MM/DD HH:mm:ss').format('HH:mm') : '');
		this.formControls["HoraFin"].setValue(data.fechaFin ? moment(data.fechaFin, 'YYYY/MM/DD HH:mm:ss').format('HH:mm') : '');
		this.formControls["NombreLugarEvento"].setValue(scriptData?.location?.name || '');
		this.formControls["Direccion"].setValue(scriptData?.location?.address?.streetAddress || '');
		this.formControls["Localidad"].setValue(scriptData?.location?.address?.addressLocality || '');
		this.formControls["Region"].setValue(scriptData?.location?.address?.addressRegion || '');
		this.formControls["PaisCodigo"].setValue(scriptData?.location?.address?.addressCountry || '');
		this.formControls["CodigoPostal"].setValue(scriptData?.location?.address?.postalCode || '');
		this.formControls["PublicacionDesde"].setValue(data.fechaPublicacionDesde ? moment(data.fechaPublicacionDesde, 'YYYY/MM/DD').toDate() : '');
		this.formControls["PublicacionHasta"].setValue(data.fechaPublicacionHasta ? moment(data.fechaPublicacionHasta, 'YYYY/MM/DD').toDate() : '');
		this.formControls["GruposInternetIds"].setValue(data.grupoInternetIds);
		this.formControls["Activo"].setValue(data.activo);

		this.panelService.setDiscardChanges(true);
	}

	manageForm(pkId, mode) {
		if (mode == "I") {
			this.gruposInternetAsignados = [];
			this.loading = false;
			this.valuedChanged();
		}
		if (pkId) {
			this.findSchema(pkId);
		}
	}

	getDataFromScript(script: string): ISchemaScript | null {
		//TODO: Se recibe un script como JSON.stringify
		//Hay que parsearlo y obtener los datos para rellenar el formulario
		//Ejemplo de script:
		/*
			"{\"@context\":\"https://schema.org\",\"@type\":\"Event\",\"name\":\"222 Concierto Flamenco en Sacromonte\",\"startDate\":\"2025-09-20T21:00\",\"endDate\":\"2025-09-20T23:00\",\"eventAttendanceMode\":\"https://schema.org/OfflineEventAttendanceMode\",\"eventStatus\":\"https://schema.org/EventScheduled\",\"location\":{\"@type\":\"Place\",\"name\":\"Cueva Flamenca El Sacromonte\",\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"Calle Sacromonte 10\",\"addressLocality\":\"Granada\",\"addressRegion\":\"Andalucía\",\"postalCode\":\"18010\",\"addressCountry\":\"ES\"}},\"image\":\"https://example.com/images/flamenco.jpg\",\"description\":\"Espectáculo de flamenco tradicional en el barrio del Sacromonte.\",\"offers\":{\"@type\":\"Offer\",\"url\":\"https://ventaonline.com/eventos/flamenco-sacromonte\",\"price\":\"40.00\",\"priceCurrency\":\"EUR\",\"availability\":\"https://schema.org/InStock\",\"validFrom\":\"2025-08-01T00:00\"}}"
		*/

		if (!script || script.length === 0) return null;
		try {
			const parsedScript = JSON.parse(script);
			return parsedScript as ISchemaScript;
		} catch (error) {
			console.error("Error parsing script JSON:", error);
			return null;
		}
	}

	ValidatorURL(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
			const valid = urlPattern.test(control.value);
			return valid ? null : { invalidUrl: true };
		};
	}

	ValidatorImageURL(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const imageUrlPattern = /(https?:\/\/.*\.(?:png|jpg))/i;
			const valid = imageUrlPattern.test(control.value);
			return valid ? null : { invalidImageUrl: true };
		};
	}

	ValidatorDatePicker(required = false): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			console.log({
				value: control.value,
				required: required,
			})
			if (required && !control.value) {
				return { required: true };
			}

			return null;
			
		}
	}

	get formControls() {
		return this.editForm.controls;
	}

	onGruposInternetChange() {
		
		if (this.gruposInternetAsignados && this.gruposInternetAsignados.length > 0) {
			if (this.formControls["GruposInternetIds"].hasError('required')) {
				this.formControls["GruposInternetIds"].setErrors(null);
			}
		}
	}

	submit() {
		const schemaFormValue: ISchemaFormValue = this.editForm.value;
		this.editForm.markAllAsTouched();
		
		if (!this.gruposInternetAsignados || this.gruposInternetAsignados.length === 0) {
			this.snackvar_service.openSnackBar(
				this.translation["CampoRequerido"] || "Debe seleccionar al menos un grupo internet",
				"",
				"red-snackbar"
			);
			this.formControls["GruposInternetIds"].setErrors({ required: true });
			this.formControls["GruposInternetIds"].markAsTouched();
			return;
		}

		this.onGruposInternetChange();

		if (this.editForm.valid) {
			this.manageApi(schemaFormValue);
		}
	}

	destroy() {
		this.panelService.setDiscardChanges(true);
		this.panelService.setClosePanel(null);
	}
	save() {
		this.loading = false;
		this.panelService.setSavePanel(null);
	}

	discard() {
		this.changeValueForm(this.schemaValue);
		this.editForm.markAllAsTouched();

		switch (this.mode) {
			case "I":
				this.gruposInternetAsignados = [];
				break;
			case "U":
			case "D":
				this.gruposInternetAsignados = this.getGruposInternetAsignados(
					this.schemaValue?.grupoInternetIds || ''
				);
				break;

			default:
				break;
		}
	}

	obtenerDualListAsignados(value: any[]): string {
		if (!value || value.length === 0) return '';
		return value.map(item => item.pkid).join(',');
	}

	generateScript(formData: ISchemaFormValue): ISchemaScript {
		const script: ISchemaScript = {
			"@context": "https://schema.org",
			"@type": "Event",
			"name": formData.NombreEvento || '',
			"startDate": formData.FechaDeInicio
				? (formData.HoraInicio
					? moment(formData.FechaDeInicio).set({
							hour: +formData.HoraInicio.split(':')[0],
							minute: +formData.HoraInicio.split(':')[1]
						}).toISOString()
					: moment(formData.FechaDeInicio).toISOString())
				: '',
			"endDate": formData.FechaDeFin
				? (formData.HoraFin 
					? moment(formData.FechaDeFin).set({
							hour: +formData.HoraFin.split(':')[0],
							minute: +formData.HoraFin.split(':')[1]
						}).toISOString() 
					: moment(formData.FechaDeFin).toISOString()) 
				: '',
			"eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
			"image": formData.URLImagen || '',
			"description": formData.DescripcionEvento || '',
			"eventStatus": "https://schema.org/EventScheduled",
			"location": {
				"@type": "Place",
				"name": formData.NombreLugarEvento || '',
				"address": {
					"@type": "PostalAddress",
					"streetAddress": formData.Direccion || '',
					"addressLocality": formData.Localidad || '',
					"addressRegion": formData.Region || '',
					"postalCode": formData.CodigoPostal || '',
					"addressCountry": formData.PaisCodigo || ''
				}
			},
			"organizer": {
				"@type": "Organization",
				"name": formData.NombreOrganizador || '',
				"url": formData.WebOrganizador || ''
			}
		};

		return script;
	}

	manageApi( formData: ISchemaFormValue ) {
		formData.GruposInternetIds = this.obtenerDualListAsignados(this.gruposInternetAsignados);
		this.loading = true;

		const scriptValue = this.generateScript(formData);

		const bodyRequest: InsUpSchemaRequest = {
			pkid: 0,
			activo: formData.Activo,
			fechaPublicacionDesde: formData.PublicacionDesde ? moment(formData.PublicacionDesde).format('YYYY/MM/DD') : '',
			fechaPublicacionHasta: formData.PublicacionHasta ? moment(formData.PublicacionHasta).format('YYYY/MM/DD') : '',
			grupoInternetIds: formData.GruposInternetIds,
			script: JSON.stringify(scriptValue),
		};

		switch (this.mode) {
			case "I":
			case "D":
				bodyRequest.pkid = 0;
				this.InsUpEventoSchema(bodyRequest);
				//insert
				break;
			case "U":
				//update
				bodyRequest.pkid = +this.pkId;
				this.InsUpEventoSchema(bodyRequest);
				break;
			default:
				break;
		}
	}

	InsUpEventoSchema(bodyRequest: InsUpSchemaRequest) {
		this.conectarApiService
			.InsUpSchema(bodyRequest)
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe(
				(response) => {
					this.nextWindow(response);
				},
				(error) => {
					this.loading = false;
				
					if (error?.error) {
					
						if (typeof error.error === 'string' && error.error.trim() !== '') {
							this.snackvar_service.openSnackBar(
								error.error,
								"",
								"red-snackbar"
							);
							return;
						}
						if (error.error?.mensajes && error.error.mensajes.length > 0) {
							error.error.mensajes.forEach((mensaje: any) => {
								const mensajeTexto = mensaje.descripcionMensaje || mensaje.codigoMensaje || "Error al guardar";
								this.snackvar_service.openSnackBar(
									mensajeTexto,
									"",
									"red-snackbar"
								);
							});
							return;
						}
					}
				
					this.httpErrorService.identificarErroresMicroservicios(error);
				}
			);
	}

	nextWindow(response: InsUpSchemaResponse) {
		this.loading = false;
    
		const successMessageKey = {
			I: "CreatedSuccessfully",
			U: "UpdatedSuccessfully",
			D: "DuplicatedSuccessfully",
		};

		if (response?.mensajes?.length > 0) {
	
			response.mensajes.forEach((element) => {
				const mensajeTexto = element?.descripcionMensaje || 
					(this.translation["schemasModule"]?.[element?.codigoMensaje]) || 
					element?.codigoMensaje || 
					"Error al guardar";
				this.snackvar_service.openSnackBar(
					mensajeTexto,
					"",
					"red-snackbar"
				);
			});
		} else {
			
			this.snackvar_service.openSnackBar(
				this.translation[successMessageKey[this.mode]],
				"",
				"green-snackbar"
			);
			this.save();
			this.destroy();
		}
	}

	notEmptyFields(grupo_cl: GrupoClientes): boolean {
		let res = true;
		if (
			grupo_cl.NombreGruposClientes.length === 0 ||
			grupo_cl.CodigoGruposClientes.length === 0
		) {
			res = false;
		}
		return res;
	}

	valuedChanged() {
		this.editForm.valueChanges.subscribe((value) => {
			if (this.padres !== null) {
				this.panelService.setDiscardChanges(false);
				if (JSON.stringify(value) === JSON.stringify(this.schemaValue)) {
					this.panelService.setDiscardChanges(true);
				}
			}
		});
	}

	validateFields(field: string) {
		return this.isValidAnyField(field);
	}

	isValidAnyField(field: string) {
		let fc_pv = this.formControls;
		return fc_pv[field].errors != null ? true : false;
	}

	getErrorMessage(field: string) {
		let fc_pv = this.editForm.get(field);
		const errorsText = {
			required: this.translation["CampoRequerido"],
			invalidUrl: this.translation["INVALID_URL"],
			invalidImageUrl: this.translation["INVALID_IMAGE_URL"],
			invalidDate: this.translation["FechaInvalida"],
			invalidHour: this.translation["HoraInvalida"]
		};

		if (fc_pv.errors) {
			for (const errorName in fc_pv.errors) {
				if (errorsText[errorName]) {
					return errorsText[errorName];
				} else {
					return "Error";
				}
			}
		}

		/* console.log({
			field: field,
			errors: fc_pv.errors
		})

		return fc_pv.errors.required
			? errorsText.required
			: errorsText[field] || "Error"; */
	}
}
